import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const CheckCircleIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon sx={{ width: '15px', height: '16px' }} {...props}>
      <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="check_circle_outline" clip-path="url(#clip0_9554_36938)">
          <path
            id="Vector"
            d="M10.3687 5.2375L6.25 9.35625L4.00625 7.11875L3.125 8L6.25 11.125L11.25 6.125L10.3687 5.2375ZM7.5 1.75C4.05 1.75 1.25 4.55 1.25 8C1.25 11.45 4.05 14.25 7.5 14.25C10.95 14.25 13.75 11.45 13.75 8C13.75 4.55 10.95 1.75 7.5 1.75ZM7.5 13C4.7375 13 2.5 10.7625 2.5 8C2.5 5.2375 4.7375 3 7.5 3C10.2625 3 12.5 5.2375 12.5 8C12.5 10.7625 10.2625 13 7.5 13Z"
            fill="#2ED2AB"
          />
        </g>
        <defs>
          <clipPath id="clip0_9554_36938">
            <rect width="15" height="15" fill="white" transform="translate(0 0.5)" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
};

export default CheckCircleIcon;
